export default __webpack_public_path__ + "static/media/empower.46dc73d6.svg";